import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_soap_3: FaireProductEntity = {
  token: "nyc-soap-3",
  type: "product",
  name: "Rose Petal Body Scrub",
  brandName: "Botanical Beauty",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8a01346a1e6c6704aad0ba0cffc6c7cb04388f5fb882fad736a5379218d21f1e.webp",
  priceDollars: 18,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/8a01346a1e6c6704aad0ba0cffc6c7cb04388f5fb882fad736a5379218d21f1e.webp",
  weight: 0.8,
  dimensions: {
    width: 4,
    height: 5,
    depth: 2,
  },
  description: "Luxury eucalyptus bath salts",
  categoryTokens: ["cat_bath-all"],
  tags: ["nyc-local", "premium", "spa", "wellness"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
